<template>
  <div>
    <NavigationBar
      titel="Neuen Abteilung anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        v-model="helpers.formIsValid"
        ref="form"
        @submit.prevent="createItem"
      >
        <division-editor v-model="division" mode="new"></division-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { CREATE_DIVISION } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import DivisionEditor from "@/components/member-management/divisions/DivisionEditor.vue";

export default {
  name: "member-management-division-new",
  components: {
    NavigationBar,
    DivisionEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],

      helpers: {
        formIsValid: false,
      },
      division: {
        title: "",
        shortTitle: "",
        sortKey: null,
        isActive: true,
      },
    };
  },

  methods: {
    createItem() {
      this.$refs.form.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${MEMBER_MANAGEMENT}${CREATE_DIVISION}`, {
          organizationId: this.$route.params.organizationId,

          title: this.division.title,
          shortTitle: this.division.shortTitle,
          sortKey: this.division.sortKey,
          isActive: this.division.isActive,
        });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
  },
};
</script>

<style></style>
